/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Workspace_Aside_Draft_DescInputs */

const en_directory_submit_workspace_aside_draft_desc = /** @type {(inputs: Directory_Submit_Workspace_Aside_Draft_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing enters review before your choice.`)
};

const zh_directory_submit_workspace_aside_draft_desc = /** @type {(inputs: Directory_Submit_Workspace_Aside_Draft_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择方案前不会进入审核。`)
};

/**
* | output |
* | --- |
* | "Nothing enters review before your choice." |
*
* @param {Directory_Submit_Workspace_Aside_Draft_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_workspace_aside_draft_desc = /** @type {((inputs?: Directory_Submit_Workspace_Aside_Draft_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Workspace_Aside_Draft_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_workspace_aside_draft_desc(inputs)
	return zh_directory_submit_workspace_aside_draft_desc(inputs)
});
export { directory_submit_workspace_aside_draft_desc as "directory.submit.workspace.aside.draft_desc" }